export default function createEventTarget() {
  return document.createElement('div')
}